import { defineMessages } from 'react-intl';

export default defineMessages({
    caption: {
        id: '_.funding_requirements.sign_document_caption',
        defaultMessage: `This document requires {requiresNonApplicantSigning, select,
        true {{formattedPersonToSign}}
        false {a}
        other {}
        } digital signature.`
    },
    caption_completed: {
        id: '_.funding_requirements.sign_document_caption_completed',
        defaultMessage: 'Your signed document is available for download.'
    },
    access_user_caption_completed: {
        id: '_.funding_requirements.sign_document_access_user_caption_completed',
        defaultMessage:
            '{formattedPersonForCaption} signed the personal guarantee.'
    },
    action: {
        id: '_.funding_requirements.sign_document_action',
        defaultMessage: 'View & Sign'
    },
    action_wet: {
        id: '_.funding_requirements.sign_document_action_wet',
        defaultMessage: 'Download & Sign'
    },
    master_loan_agreement_label: {
        id: '_.draw_down.step_buttons.loan_agreement.label',
        defaultMessage: 'Credit Agreement'
    },
    secci_label: {
        id: '_.draw_down.step_buttons.secci.label',
        defaultMessage: 'SECCI'
    },
    secci_caption: {
        id: '_.draw_down.step_buttons.secci.caption',
        defaultMessage:
            'A standardised form designed to show you exactly what your finance agreement contains.'
    },
    reasonable_explanation_label: {
        id: '_.draw_down.step_buttons.reasonable_explanation.label',
        defaultMessage: 'Pre-contract Explanation'
    },
    reasonable_explanation_caption: {
        id: '_.draw_down.step_buttons.reasonable_explanation.caption',
        defaultMessage:
            'An explanation of the credit product you are considering entering into.'
    },
    guarantee_label: {
        id: '_.draw_down.step_buttons.guarantor_agreement.label',
        defaultMessage:
            '{requiresNonApplicantSigning, select, true {{formattedPersonToSign}} false {Your} other {}} Personal Guarantee'
    },
    repeat_loan_agreement: {
        id: '_.draw_down.step_buttons.repeat_loan_agreement.label',
        defaultMessage: 'Credit Agreement'
    },
    companies_house_charge_label: {
        id: '_.draw_down.step_buttons.companies_house_charge.label',
        defaultMessage: 'Debenture / Scottish Bond'
    },
    title: {
        id: '_.draw_down.sign_documents.title',
        defaultMessage: 'Sign your documents ({doneTasks}/{totalTasks})'
    },
    subtitle: {
        id: '_.draw_down.sign_documents.subtitle',
        defaultMessage: 'Next - we have a few documents for you to sign'
    },
    RLSSubtitle: {
        id: '_.draw_down.sign_documents.rls_subtitle',
        defaultMessage:
            'Next - we have a few documents for you to sign. We usually aim to minimise the amount of paperwork, but as this scheme is guaranteed by the government there are few more documents we need you to read and sign'
    },
    nextStep: {
        id: '_.draw_down.sign_documents.nextStep',
        defaultMessage: 'Next'
    },
    back: {
        id: '_.draw_down.sign_documents.back',
        defaultMessage: 'Back'
    },
    electronicSignDocumentsTitle: {
        id: '_.draw_down.sign_documents.electronicSignDocumentsTitle',
        defaultMessage: 'Electronically sign'
    },
    electronicSignDocumentsSubTitle: {
        id: '_.draw_down.sign_documents.electronicSignDocumentsSubTitle',
        defaultMessage: 'To be completed online'
    },
    wetSignDocumentsTitle: {
        id: '_.draw_down.sign_documents.wetSignDocumentsTitle',
        defaultMessage: 'Print and sign'
    },
    wetSignDocumentsSubTitle: {
        id: '_.draw_down.sign_documents.wetSignDocumentsSubTitle',
        defaultMessage: 'Please print these off, sign and return'
    },
    wetSignDocumentsFooter: {
        id: '_.draw_down.sign_documents.wetSignDocumentsFooter',
        defaultMessage:
            'Once you sign these documents please send a scanned copy to {documentsLink}'
    },
    documentsEmailAddress: {
        id: '_.draw_down.sign_documents.emailAddress',
        defaultMessage: 'documents@iwoca.co.uk'
    },
    companyName: {
        id: '_.draw_down.sign_documents.companyName',
        defaultMessage: 'Company name'
    },
    addressLineOne: {
        id: '_.draw_down.sign_documents.addressLineOne',
        defaultMessage: 'Address line one'
    },
    addressLineTwo: {
        id: '_.draw_down.sign_documents.addressLineTwo',
        defaultMessage: 'Address line two'
    },
    addressLineThree: {
        id: '_.draw_down.sign_documents.addressLineThree',
        defaultMessage: 'N/A'
    },
    completeStepsTooltip: {
        id: '_.draw_down.sign_documents.missing_steps_tooltip',
        defaultMessage: 'It looks like you missed a step'
    }
});
